import { render } from "./OnboardingSteps.vue?vue&type=template&id=2afc2af2&scoped=true"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js"

import "./OnboardingSteps.vue?vue&type=style&index=0&id=2afc2af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afc2af2"]])

export default __exports__